<template>
    <div class="p-20px">
        <div class="header flex items-center mb-20px justify-between"
           >
            <div class="flex items-center">
                <div class="w-28px h-28px cursor-pointer" @click="handleBack">
                    <img src="@/assets/images/mine/left.webp" alt="" class="w-full h-full" />
                </div>
            </div>
            <div class="text-16px font-bold"> 
                Album
            </div>
            <div class="w-20px">

            </div>
        </div>
        <div class="album-list">
            <div v-for="(item, index) in list" :key="item.id" class="album-item "
                @click="handlePreviewAlbum(item.url, item.typeSee, item, index as number)">
                <AppImage :src="item.url" alt="avatar" width="100%" height="100%" :show-loading="true"
                    :show-error="true" :lazy-load="false" :custom-loading="true" :custom-error="true"
                    fallback="@/assets/images/home/sitemap.webp" fit="cover"
                    @error="() => console.log('Image error:', item.url)" />

                <div v-if="!item.isUnlock" class="locked-overlay">
                    <img src="@/assets/images/other/lock.svg" class="lock-icon" />
                </div>
            </div>
        </div>
        <!-- 全屏图片预览 -->
        <FullscreenImagePreview v-model:show="showImagePreview" :images="previewImages" :infoItem="infoItem"
            :start-position="previewStartPosition" @close="handleCloseImagePreview"
            :isShowSetAsBackdrop="isShowSetAsBackdrop" 
            @unlockSuccess="handleUnlockSuccess" :isShowbackDrop="isShowbackDrop"
            :numberChatMessages="numberChatMessages" :numberChatMessagesTotal="levelExpOrigin" />
    </div>
</template>
<script setup lang="ts">
import { FullscreenImagePreview } from '@/components/feedback'
import { AppImage } from '@/components/display'
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useBackgroundStore } from '@/stores/background'
import { detailDB } from '@/utils/detailDB'
import { MessageAPI } from '@/services/message'
import { showLoadingToast, showSuccessToast } from 'vant'
const { t } = useI18n()
const backgroundStore = useBackgroundStore()
const router = useRouter()
const route = useRoute()
const list = ref<any>()
const infoItem = ref<any>(null)
    const levelExpOrigin = ref()

// 全屏预览状态
const showImagePreview = ref(false)
// 预览图片
const previewImages = ref<string[]>([])
const isShowSetAsBackdrop = ref(false)
const numberChatMessages = ref<number | undefined>(0)
const previewStartPosition = ref(0)
const isShowbackDrop = ref(false)
const id = ref()



/**
* 预览专辑
*/
const handlePreviewAlbum = (url?: string, typeSee?: number, item?: any, index?: number) => {
    isShowSetAsBackdrop.value = !item.isUnlock
    infoItem.value = item
    numberChatMessages.value = index
    // 构建图片数组，可以包含多张图片
    const images = []

    // 添加背景图片
    if (url) {
        images.push(url)
    }

    // 如果没有图片，显示提示
    if (images.length === 0) {
        console.warn('没有可预览的图片')
        return
    }

    previewImages.value = images
    previewStartPosition.value = 0
    showImagePreview.value = true
    isShowbackDrop.value = true
}
/**
 * 处理解锁成功
*/
const handleUnlockSuccess = async (imageId: number) => {
    // 更新本地相册数据，将解锁的图片标记为已解锁
    if (backgroundStore.backgroundList) {
        const unlockedItem = backgroundStore.backgroundList.find((item: any) => item.id === imageId)
        if (unlockedItem) {
            unlockedItem.isUnlock = true
        }
    }
    // 当前预览应立即去除遮罩
    isShowSetAsBackdrop.value = false
    await backgroundStore.getBackgroundList(id.value)
}

/**
 * 关闭图片预览
 */
 const handleCloseImagePreview = () => {
    showImagePreview.value = false
    previewImages.value = []
    previewStartPosition.value = 0
}

/**
 * 返回
 */
const handleBack = () => {
    router.back()
}

onMounted(() => {
    list.value = JSON.parse(decodeURIComponent(route.query.list))
    id.value = route.query.id as string
    levelExpOrigin.value = Number(route.query.levelExpOrigin )
})
</script>
<style lang="scss" scoped>
.album-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}

.album-item {
    width: 105px;
    height: 158px;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
}

.locked-overlay {
    position: absolute;
    inset: 0;
    background: rgba(1, 3, 27, 0.5);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.lock-icon {
    width: 13px;
    height: 13px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>